var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTodayEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 331.568,
    height: 343.969,
    viewBox: "0 0 331.568 343.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .pastES1,.pastES2{fill:#f0f8ed}.pastES3{fill:#e0f1da}.pastES1,.pastES2,.pastES4{stroke:#c1e3b5;stroke-miterlimit:10}.pastES2{stroke-width:.75px}.pastES4{fill:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    transform: "translate(-18.325 -64.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    fill: "#f0f8ed",
    d: "M308.154 348.3a112.336 112.336 0 0 1-17.182 14.467C234.921 402.981 168.6 391.258 154.5 388.395c-20.815-4.228-61.049-12.4-90.138-46.607-44.009-51.754-37.156-133.29-3.02-187.114 6.244-9.845 39.227-64.488 106.265-73.251 40.57-5.3 87.862 5.393 122.11 34.085 71.891 60.229 66.773 181.902 18.437 232.792z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    d: "M345.5 196.021h-16.618a7 7 0 0 0 2.389-5.27 7.027 7.027 0 0 0-7.027-7.027h-17.988a7.881 7.881 0 0 0-5.727-2.459H282.61a7.9 7.9 0 0 0-7.9 7.9 7.915 7.915 0 0 0 .1 1.23h-4.137a3.334 3.334 0 0 0-2.429 5.621h-10.57a4.392 4.392 0 0 0-4.392 4.392 4.392 4.392 0 0 0 4.392 4.392H345.5a4.392 4.392 0 0 0 4.392-4.392 4.393 4.393 0 0 0-4.392-4.387z",
    className: "pastES3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    d: "M130.16 261.356H104.8c-.276-3.616-3.619-6.473-7.705-6.473h-8.45v-.162c0-3.842-3.459-6.957-7.726-6.957H50.383c-4.267 0-7.727 3.115-7.727 6.957a6.31 6.31 0 0 0 .361 2.1h-8.446a6.551 6.551 0 0 0-6.442 4.531h-5.672a3.943 3.943 0 0 0-4.132 3.721 3.943 3.943 0 0 0 4.132 3.721h107.7a3.943 3.943 0 0 0 4.132-3.721 3.943 3.943 0 0 0-4.129-3.717z",
    className: "pastES3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9",
    d: "M0 0H1.109V47.664H0z",
    className: "pastES1",
    transform: "translate(175.889 236.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    d: "M324.918 270.358a4.275 4.275 0 0 0-3.662-1.545l-23.362 1.975a4.273 4.273 0 0 0-2.9 7.026l4.945 5.818-35.365 26.458-13.134-14.356a5.129 5.129 0 0 0-6.8-.686l-74.594 54.217-20.08-14.154a5.129 5.129 0 0 0-6.194.215l-57.131 46.539a5.128 5.128 0 0 0 6.478 7.952l54.117-44.082 19.9 14.028a5.131 5.131 0 0 0 5.971-.043l73.857-53.681 13.177 14.4a5.128 5.128 0 0 0 6.856.645l39.6-29.623 5.442 6.4a4.274 4.274 0 0 0 7.365-1.59l6.319-22.027a4.274 4.274 0 0 0-.805-3.886z",
    className: "pastES3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    width: 19.44,
    height: 33.181,
    className: "pastES1",
    rx: 3.208,
    transform: "translate(125.538 374.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    d: "M5.048 0H14.2a5.243 5.243 0 0 1 5.24 5.243v13.288a5.243 5.243 0 0 1-5.24 5.243H5.243A5.243 5.243 0 0 1 0 18.531V5.048A5.048 5.048 0 0 1 5.048 0z",
    className: "pastES1",
    transform: "translate(154.068 383.891)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    width: 19.441,
    height: 42.161,
    className: "pastES1",
    rx: 3.551,
    transform: "translate(182.599 365.504)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    width: 19.441,
    height: 49.254,
    className: "pastES1",
    rx: 3.556,
    transform: "translate(211.129 358.411)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    width: 19.441,
    height: 68.076,
    className: "pastES1",
    rx: 3.297,
    transform: "translate(239.659 339.589)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    width: 19.441,
    height: 83.13,
    className: "pastES1",
    rx: 2.559,
    transform: "translate(268.189 324.535)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    d: "M194.045 281.553a8.051 8.051 0 0 1 1.391 5.928 8.319 8.319 0 0 1-.3 1.227l1.252-.608a1.885 1.885 0 1 1 1.649 3.391L185.9 297.4a13.983 13.983 0 0 1-9.838.948c-3.17-1.008-5.705-3.425-7.531-7.184a15.079 15.079 0 0 1-1.346-10.081 26.3 26.3 0 0 1 4.7-9.632c1.587-2.228 2.244-4.223 1.952-5.927a3.909 3.909 0 0 0-1.41-2.46.628.628 0 0 1 .114-1.1c.169-.07 4.183-1.7 7.814.04a8.319 8.319 0 0 1 3.95 4.246 9.233 9.233 0 0 0 .18-1.193 5.8 5.8 0 0 1-.133-5.224.627.627 0 0 1 .549-.31 5.574 5.574 0 0 1 4.519 2.817 10.533 10.533 0 0 1 5.474 1.08 7.969 7.969 0 0 1 3.7 3.348c.779 1.6-.951 2.87-2.478 3.988a11.747 11.747 0 0 0-1.777 1.475c-.4.548-.436.835-.376.959",
    className: "pastES2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    d: "M185.848 297.422a17.266 17.266 0 0 1-5.934-2.893c-9.89-8.549-1.518-18.23-1.518-18.23 6.6-7.706 6.093-11.284 6.093-11.284",
    className: "pastES2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    cx: 0.451,
    cy: 0.451,
    r: 0.451,
    className: "pastES2",
    transform: "translate(191.74 267.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    d: "M198.787 267.54l-.85.052s-.807.058-.275.543a1.276 1.276 0 0 0 .442.258 1.4 1.4 0 0 0 .413.112 5.155 5.155 0 0 0 .27-.965z",
    className: "pastES2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    d: "M193.451 278.306a8.03 8.03 0 0 0 .554 3.192s-4.569-5.072-10.154.78",
    className: "pastES2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    d: "M193.956 272.944s-.074.376-.164.98",
    className: "pastES2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    d: "M190.836 272.684s2.811 2.989 7.184-.075a1.95 1.95 0 0 1 .533-.269c.529-.166 1.418-.232 1.193 1.329a4.316 4.316 0 0 1-1.392 2.579 9.567 9.567 0 0 1-6.783 2.18",
    className: "pastES2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    d: "M195.368 271.311a2.245 2.245 0 0 1-2.444-.489",
    className: "pastES2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    d: "M183.851 282.278s5.545-6.668 10.743.191a6.938 6.938 0 0 1 .542 6.239s2.695-2.061 3.772.263c0 0-1.3-1.631-3.876.612l-1.158 1.173s2.515-5.789-2.239-9.36a4.99 4.99 0 0 0-3.452-1 8.358 8.358 0 0 0-4.332 1.882z",
    className: "pastES3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    d: "M199.577 272.433s-.246 4.568-8.078 5.094c0 0-1.359.356.034.823 0 0 8.83.202 8.044-5.917z",
    className: "pastES3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    d: "M172.267 262.187s5.307-2.717 9.856.993c0 0 1.89 1.8 1.986 3.251 0 0-.767 3.92-4.834 8.816 0 0-3.43 3.853-3.809 6.881 0 0-.98-.634 5.357-11.761a5.272 5.272 0 0 0 .706-2.26c.137-2.13-.997-5.479-9.262-5.92z",
    className: "pastES3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    d: "M184.642 259.575s2.53-.681 4.782 2.762a2.366 2.366 0 0 1-1.276 1.521s.685-2.463-3.506-4.283z",
    className: "pastES3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    d: "M190.186 295.311s-7.843 2.548-14-5.459a13.953 13.953 0 0 0 9.714 7.548z",
    className: "pastES3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    d: "M204.461 281.278h-51.424l-7.014-56.994 1.094-.257 6.857 55.719h49.543l9.263-79.317 1.1.245z",
    className: "pastES1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    d: "M200.006 299.995l-4.515 12.493a4.44 4.44 0 0 1-4.174 2.93h-25.14a4.438 4.438 0 0 1-4.173-2.93l-8.229-22.766a4.437 4.437 0 0 1 4.173-5.946h41.6a4.437 4.437 0 0 1 4.173 5.946l-3.713 10.273",
    className: "pastES1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    d: "M178.584 83.318a28.276 28.276 0 0 0-1.419 4.172c-3.854 10.369-15.885 12.258-15.99 12.281a.4.4 0 0 0-.1.015c-.835.144-20.655 3.711-31.8 10.581-10.035 5.849-16.209 15.334-18.367 28.205a67.011 67.011 0 0 0-.68 15.457c42.648-19.128 81.507-15.422 96.35-12.9a140.884 140.884 0 0 1 39.309 12.8c.553-4.461 1.278-9.958.373-15.354a44.717 44.717 0 0 0-5.073-14.839 35.674 35.674 0 0 0-13.287-13.368c-11.144-6.871-30.968-10.439-31.809-10.581a.264.264 0 0 0-.088-.018 25.019 25.019 0 0 1-9.962-4.354 5.756 5.756 0 0 1-2.171-6.179c1.035-3.021 5.113-12.612 11.362-16.122 1.713-.972 2.506-3.551 1.755-5.768s-2.739-3.232-4.453-2.27c-5.271 2.968-9.13 8.674-11.439 12.94-.58 1.068-1.617 3.144-2.513 5.3",
    className: "pastES1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    d: "M238.977 156.88v-.126c-5.185-2.146-23.819-11.952-60.649-12.3v-.01c-31.925-.556-61.1 12.306-61.1 12.306v.25c-.015.493 0 .755 0 1.231v28.027a60.437 60.437 0 0 0 5.812 25.963.062.062 0 0 0 .008.024c.024.047.048.1.072.15q.393.834.81 1.644c.3.58.682 1.286 1.135 2.1.222.389.476.81.738 1.239a60.776 60.776 0 0 0 4.073 5.986c.182.215 5.911 6.98 7.673 8.249l.01.006v.005a60.8 60.8 0 0 0 10.818 7.716c.079.047.159.087.238.135a60.449 60.449 0 0 0 25.74 7.471l3.826.118h.047l.184.006h.016v-.013l3.425-.115a60.794 60.794 0 0 0 57.129-60.68v-28.036c-.005-.473.018-.968-.005-1.346z",
    className: "pastES1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    d: "M178.176 247.062h-.125z",
    className: "pastES1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    d: "M200.006 299.995l-4.515 12.493a4.44 4.44 0 0 1-4.174 2.93h-25.14a4.438 4.438 0 0 1-4.173-2.93l-8.229-22.766a4.437 4.437 0 0 1 4.173-5.946h41.6a4.437 4.437 0 0 1 4.173 5.946l-3.713 10.273",
    className: "pastES4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_498"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    width: 55.018,
    height: 8.838,
    className: "pastES1",
    rx: 4.419,
    transform: "translate(151.108 278.582)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    d: "M184.082 85.5a28.286 28.286 0 0 1 1.42-4.172c.895-2.155 1.932-4.231 2.512-5.3A39.2 39.2 0 0 1 195.5 66.01a2.737 2.737 0 0 0-3.2-.349c-5.272 2.968-9.13 8.673-11.439 12.939-.581 1.069-1.618 3.145-2.513 5.3a28.288 28.288 0 0 0-1.42 4.172 18.382 18.382 0 0 1-8.78 9.695c.888-.154 12.216-2.267 15.934-12.267z",
    className: "pastES3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    d: "M213.495 139.136c-13.863-2.353-48.675-5.74-87.958 9.407a170.9 170.9 0 0 1 80.807-6.831 140.849 140.849 0 0 1 39.309 12.8c.215-1.738.456-3.635.617-5.621a141.15 141.15 0 0 0-32.775-9.755z",
    className: "pastES3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    d: "M117.825 136.581c2.158-12.871 8.332-22.356 18.368-28.2a52.325 52.325 0 0 1 7.536-3.736 68.84 68.84 0 0 0-14.688 6.312c-10.036 5.849-16.209 15.334-18.367 28.2a66.949 66.949 0 0 0-.68 15.456q3.583-1.606 7.127-3a66.543 66.543 0 0 1 .704-15.032z",
    className: "pastES3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    d: "M206.086 239.08l-3.425.12v.013h-.016l-.185-.005h-.047v.005h-.125l.125-.005-3.825-.122a59 59 0 0 1-25.741-7.721c-.079-.049-.159-.09-.238-.14a60.894 60.894 0 0 1-10.818-7.973v-.006l-.01-.006c-1.762-1.311-7.491-8.3-7.673-8.525a62.589 62.589 0 0 1-4.073-6.187c-.262-.443-.516-.878-.739-1.28-.452-.837-.833-1.567-1.135-2.166q-.417-.837-.81-1.7c-.024-.05-.048-.107-.071-.156a.068.068 0 0 1-.008-.025 64.19 64.19 0 0 1-5.812-26.831v-26.931a160.865 160.865 0 0 0-24.472 7.9v.246c-.016.493 0 .755 0 1.231v28.027A60.429 60.429 0 0 0 122.8 212.8a.056.056 0 0 0 .008.023c.024.048.048.1.071.151q.393.834.81 1.644c.3.579.683 1.286 1.136 2.1.222.389.476.81.738 1.238a60.613 60.613 0 0 0 4.073 5.987c.182.215 5.911 6.98 7.673 8.249l.009.006a60.775 60.775 0 0 0 10.817 7.715c.08.048.159.088.239.135a60.436 60.436 0 0 0 25.74 7.472l3.826.118h.046l.185.006h.016v-.013l3.425-.115a60.475 60.475 0 0 0 27.964-8.762c-1.153.146-2.317.254-3.49.326z",
    className: "pastES3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    d: "M199.009 287.823h-41.246c-1.151 0-3.57-.87-4.231 0s.563 3.311.955 4.31l8.159 20.842a3.491 3.491 0 0 0 3.276 2.123h4.488l-6.863-17.53a4.542 4.542 0 0 1 .649-4.489 5.391 5.391 0 0 1 4.351-2.089l34.142.124c.734-1.28 1.138-4.3.862-3.678-.251.578-3.391.387-4.542.387z",
    className: "pastES3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    d: "M178.584 83.318a28.276 28.276 0 0 0-1.419 4.172c-3.854 10.369-15.885 12.258-15.99 12.281a.4.4 0 0 0-.1.015c-.835.144-20.655 3.711-31.8 10.581-10.035 5.849-16.209 15.334-18.367 28.205a67.011 67.011 0 0 0-.68 15.457c42.648-19.128 81.507-15.422 96.35-12.9a140.884 140.884 0 0 1 39.309 12.8c.553-4.461 1.278-9.958.373-15.354a44.717 44.717 0 0 0-5.073-14.839 35.674 35.674 0 0 0-13.287-13.368c-11.144-6.871-30.968-10.439-31.809-10.581a.264.264 0 0 0-.088-.018 25.019 25.019 0 0 1-9.962-4.354 5.756 5.756 0 0 1-2.171-6.179c1.035-3.021 5.113-12.612 11.362-16.122 1.713-.972 2.506-3.551 1.755-5.768s-2.739-3.232-4.453-2.27c-5.271 2.968-9.13 8.674-11.439 12.94-.58 1.068-1.617 3.144-2.513 5.3",
    className: "pastES4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    d: "M238.977 156.88v-.126c-5.185-2.146-23.819-11.952-60.649-12.3v-.01c-31.925-.556-61.1 12.306-61.1 12.306v.25c-.015.493 0 .755 0 1.231v28.027a60.437 60.437 0 0 0 5.812 25.963.062.062 0 0 0 .008.024c.024.047.048.1.072.15q.393.834.81 1.644c.3.58.682 1.286 1.135 2.1.222.389.476.81.738 1.239a60.776 60.776 0 0 0 4.073 5.986c.182.215 5.911 6.98 7.673 8.249l.01.006v.005a60.8 60.8 0 0 0 10.818 7.716c.079.047.159.087.238.135a60.449 60.449 0 0 0 25.74 7.471l3.826.118h.047l.184.006h.016v-.013l3.425-.115a60.794 60.794 0 0 0 57.129-60.68v-28.036c-.005-.473.018-.968-.005-1.346z",
    className: "pastES4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    d: "M178.176 247.062h-.125z",
    className: "pastES4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayEmptyState);
export default __webpack_public_path__ + "static/media/today-empty-state.e9f8f2683d9e33e50315aa66e86b09e7.svg";
export { ForwardRef as ReactComponent };